import { useMemo } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { CssBaseline, StyledEngineProvider } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { AuthProvider } from "contexts/AuthContext";

import themes from "themes";

import NavigationScroll from "layout/NavigationScroll";
import ApplicationRoutes from "ApplicationRoutes";

// Create a client
const queryClient = new QueryClient();

const App = () => {
  const customization = useSelector((state) => state.customization);
  const theme = useMemo(() => themes(customization), [customization]);

  return (
    <QueryClientProvider client={queryClient}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <NavigationScroll>
            <AuthProvider>
              <ApplicationRoutes />
            </AuthProvider>
          </NavigationScroll>
        </ThemeProvider>
      </StyledEngineProvider>
    </QueryClientProvider>
  );
};

export default App;
